import SimpleBar from "simplebar-react"
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./styles/ProjectsSelect.scss"
import useNoun from "../../../hooks/useNoun";
import { ICategory } from "../types";
import { categories } from "../../../constants/categories";

interface ICategoriesSelect {
	chosenItems: ICategory[]
	setChosenItems: (list: ICategory[]) => void
}

export default function CategoriesSelect({ chosenItems, setChosenItems } : ICategoriesSelect) {

	const [isActive, setIsActive] = useState(false),
	mainRef = useRef<HTMLDivElement>(null),
	getNoun = useNoun(),
	{ t } = useTranslation(),
	allCheckboxRef = useRef<HTMLInputElement>(null);

	const handleSelectCategory = (category: ICategory) => {		if(!chosenItems) return;
				if (chosenItems.some(item => item.value === category.value)) {
			setChosenItems(chosenItems.filter(item => item.value !== category.value))
		} else {
			const result: ICategory[] = [];
			categories.forEach(item => {
				if(item.value === category.value) {
					result.push(category);
				}
				if(chosenItems.some(chosenItem => chosenItem.value === item.value)) {
					result.push(item);
				}
			})
			
			setChosenItems(result);
		}
	}

	const handleCheckedAll = useCallback((checkAll: boolean) => {
		if (!chosenItems) return;
		const chosenLength = chosenItems?.length || 0;
		setChosenItems((categories.length !== chosenLength && checkAll) ? categories : [])
	}, [chosenItems, setChosenItems]);

	useEffect(() => {
		if(mainRef.current) {
			const handleClickOutside = (event: MouseEvent) => {
				if (mainRef.current && !mainRef.current.contains(event.target as Node)) {
					setIsActive(false);
				}
			};
			document.addEventListener('mousedown', handleClickOutside);
			return () => document.removeEventListener('mousedown', handleClickOutside);
		}
	}, [mainRef]);

	useEffect(() => {
		if(allCheckboxRef.current && chosenItems && chosenItems.length === 0) {
			setChosenItems(categories);
			if(!allCheckboxRef.current.checked) allCheckboxRef.current.checked = true;
		}
		if(chosenItems && chosenItems.length === categories.length && allCheckboxRef.current) {
			allCheckboxRef.current.checked = true;
		}
	}, []);

	useEffect(() => {
		if(!allCheckboxRef.current || !chosenItems) return;
		if(chosenItems.length !== categories.length) {
			allCheckboxRef.current.checked = false;
		} else {
			allCheckboxRef.current.checked = true;
		}
	}, [chosenItems]);

	return (
		<div className={`projects-select drop-down is-min${isActive ? " is-active" : ""}`} ref={mainRef}>
			<button className="projects-select__target drop-down__target" type="button" aria-label={(chosenItems && chosenItems.length) ? `${getNoun(chosenItems.length, "categories")}` : t("analytics_page.statistic_report.project_category")} onClick={() => setIsActive(!isActive)}>
				<span>
					<span>
						{
							(chosenItems && chosenItems.length)
						? 
							chosenItems.length === categories.length 
						? 
							t("analytics_page.statistic_report.all_categories") 
						: 
							`${getNoun(chosenItems.length, "categories")}`
						:
							t("analytics_page.statistic_report.project_category")
						}
					</span>
				</span>
				<svg width="24" height="24">
					<use href="#drop-down-arrow"></use>
				</svg>
			</button>
			<div className="projects-select__block drop-down__block">
				<SimpleBar className="projects-select__block-inner">
					<ul className="projects-select__list">
						{(categories && categories.length) ? (
							<li key="all-categories">
								<label className="popup-checkbox">
									<input onChange={(event) => handleCheckedAll(event.currentTarget.checked)}
										type="checkbox" name="all"
										className="popup-checkbox__input"
										ref={allCheckboxRef}
									/>
									<span className="popup-checkbox__element">
										<svg width="11" height="8" viewBox="0 0 11 8">
											<use xlinkHref="#check"></use>
										</svg>
									</span>
									<span className="popup-checkbox__text" style={{
										whiteSpace: "nowrap",
										textOverflow: "ellipsis",
										overflow: "hidden"
									}}>
										<b>{t("analytics_page.statistic_report.all_categories")}</b>
									</span>
								</label>
							</li>
						) : null}
						{
							categories.length ? categories
								.filter(category => chosenItems?.some(item => item.value === category.value))
								.map(category =>
								<li key={category.value}>
									<label className="popup-checkbox">
										<input onChange={_ => handleSelectCategory(category)}
											checked={chosenItems?.some(item => item.value === category.value)}
											type="checkbox" name={category.value}
											className="popup-checkbox__input"
										/>
										<span className="popup-checkbox__element">
											<svg width="11" height="8" viewBox="0 0 11 8">
												<use xlinkHref="#check"></use>
											</svg>
										</span>
										<span className="popup-checkbox__text" style={{
											whiteSpace: "nowrap",
											textOverflow: "ellipsis",
											overflow: "hidden"
										}}>
											{t(`timesheet_page.categories.${category.label}`)}
										</span>
									</label>
								</li>
							) : <></>
						}
						{
							categories.length ? categories
								.filter(category => !(chosenItems?.some(item => item.value === category.value)))
								.map(category =>
								<li key={category.value}>
									<label className="popup-checkbox">
										<input onChange={_ => handleSelectCategory(category)}
											checked={chosenItems?.some(item => item.value === category.value)}
											type="checkbox" name={category.value}
											className="popup-checkbox__input"
										/>
										<span className="popup-checkbox__element">
											<svg width="11" height="8" viewBox="0 0 11 8">
												<use xlinkHref="#check"></use>
											</svg>
										</span>
										<span className="popup-checkbox__text" style={{
											whiteSpace: "nowrap",
											textOverflow: "ellipsis",
											overflow: "hidden"
										}}>
											{t(`timesheet_page.categories.${category.label}`)}
										</span>
									</label>
								</li>
							) : <></>
						}
					</ul>
				</SimpleBar>
			</div>
		</div>
	)
}